import { Check } from "lucide-react";
import JudiMark from "../../ui/JudiMark";

function BoardMockup() {
  const columns = [
    {
      emoji: "📋",
      name: "Work",
      color: "bg-warm-blue/20 text-warm-blue",
      tasks: [
        { title: "Design new landing page", priority: "high", hasDate: true, done: false },
        { title: "Review pull requests", priority: "medium", hasDate: false, done: false },
        { title: "Update API docs", priority: "low", hasDate: true, done: true },
      ],
    },
    {
      emoji: "🏠",
      name: "Personal",
      color: "bg-emerald-400/20 text-emerald-500",
      tasks: [
        { title: "Grocery shopping", priority: "medium", hasDate: true, done: false },
        { title: "Call dentist", priority: "low", hasDate: false, done: true },
      ],
    },
    {
      emoji: "💡",
      name: "Ideas",
      color: "bg-amber-400/20 text-amber-500",
      tasks: [
        { title: "Blog post on React 19", priority: "low", hasDate: false, done: false },
        { title: "Side project: habit app", priority: "medium", hasDate: true, done: false },
        { title: "Learn Rust basics", priority: "low", hasDate: false, done: false },
      ],
    },
  ];

  const priorityDot: Record<string, string> = {
    high: "bg-red-400",
    medium: "bg-amber-400",
    low: "bg-emerald-400",
  };

  return (
    <div className="bg-warm-bg-card border border-warm-border rounded-2xl shadow-soft-lg overflow-hidden">
      {/* Title bar */}
      <div className="flex items-center gap-2 px-4 py-3 border-b border-warm-border bg-warm-bg-elevated">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-red-400/80" />
          <div className="w-3 h-3 rounded-full bg-amber-400/80" />
          <div className="w-3 h-3 rounded-full bg-emerald-400/80" />
        </div>
        <div className="flex-1 flex items-center justify-center gap-2">
          <JudiMark className="w-4 h-4" />
          <span className="text-xs font-semibold text-warm-text-secondary">JuDI</span>
        </div>
        <div className="w-12" />
      </div>

      {/* Board columns */}
      <div className="flex gap-3 p-4 overflow-x-auto">
        {columns.map((col) => (
          <div key={col.name} className="flex-1 min-w-[140px]">
            <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium mb-3 ${col.color}`}>
              <span>{col.emoji}</span>
              <span>{col.name}</span>
            </div>
            <div className="space-y-2">
              {col.tasks.map((task, i) => (
                <div
                  key={i}
                  className={`bg-warm-bg-base border border-warm-border-subtle rounded-lg p-2.5 text-xs ${
                    task.done ? "opacity-50" : ""
                  }`}
                >
                  <div className="flex items-start gap-2">
                    <div
                      className={`w-3.5 h-3.5 mt-0.5 rounded border shrink-0 flex items-center justify-center ${
                        task.done
                          ? "bg-warm-blue border-warm-blue"
                          : "border-warm-border"
                      }`}
                    >
                      {task.done && <Check className="w-2.5 h-2.5 text-white" />}
                    </div>
                    <span
                      className={`text-warm-text-primary leading-tight ${
                        task.done ? "line-through" : ""
                      }`}
                    >
                      {task.title}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 mt-1.5 ml-5">
                    <div className={`w-2 h-2 rounded-full ${priorityDot[task.priority]}`} />
                    {task.hasDate && (
                      <span className="text-warm-text-tertiary text-[10px]">📅 Mar 16</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BoardMockup;
